module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Page"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0431d6a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Page.vue
// module id = 171
// module chunks = 4